import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var simDeclarationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: true,
  stepDetailsProps: {
    title: 'STEP 6',
    heading: 'SIM Declaration',
    avatarIcon: 'SimIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    ownerName: {
      label: 'SIM owner name',
      placeholder: 'Owner Name'
    },
    mobileNumber: {
      label: 'Mobile number',
      inputRegex: '^[6-9]{1}[0-9]*$',
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter 10-digit mobile number',
      validationRegex: '^\\d{10}$',
      maxLength: 10
    }
  },
  dropdownsDataProps: {
    numberOfConnections: {
      label: 'Total number of connections',
      placeholder: 'Select total number of connections',
      postfixIconName: 'DownChevronIcon',
      filterKey: 'subHeading',
      clearSearchOnDropdownListChange: false
    },
    providerName: {
      label: 'SIM provider',
      placeholder: 'Enter provider name',
      postfixIconName: 'DownChevronIcon',
      filterKey: 'subHeading',
      dropdownList: [],
      clearSearchOnDropdownListChange: false
    },
    simCountPerProvider: {
      label: 'No. of SIM',
      placeholder: '0',
      filterKey: 'subHeading',
      clearSearchOnDropdownListChange: false
    },
    reasonDropdown: {
      label: 'Reason for multiple connections',
      placeholder: 'Enter reason for multiple connections',
      postfixIconName: 'DownChevronIcon',
      filterKey: 'subHeading',
      dropdownList: [],
      clearSearchOnDropdownListChange: false
    },
    relationship: {
      label: 'Relationship',
      placeholder: 'Select relationship',
      filterKey: 'subHeading',
      dropdownList: [],
      clearSearchOnDropdownListChange: false
    },
    simProvider: {
      label: 'SIM provider',
      placeholder: 'Select SIM provider',
      filterKey: 'subHeading',
      dropdownList: [],
      clearSearchOnDropdownListChange: false
    }
  },
  calloutProps: {
    description: 'As per DOT rules, declare all the existing mobile connections owned by you.',
    iconName: 'InfoIcon',
    state: 'lilac'
  },
  addProviderButtonProps: {
    title: 'Add Another Provider',
    buttonType: 'tertiary',
    iconName: 'AddIcon'
  }
};
export var validatedAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};